define(['jquery', 'jquery.transit', 'modernizr', 'container', 'module-home-header', 'module-home-company',
        'module-home-films', 'module-home-tv', 'module-home-news', 'module-home-gallery', 'module-home-games'],
    function ($, transit, modernizr, container, moduleHomeHeader, moduleHomeCompany,
              moduleHomeFilms, moduleHomeTv, moduleHomeNews, moduleHomeGallery, moduleHomeGames) {

        return (function () {

            const name = 'home';

            const model = container.getBaseModel(name);
            const view = container.getBaseView(name);
            //const pubSub = container.getPublishSubscribe();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {};

            /* view */

            view.publicVars = {};

            view.privateVars = {
                itemsKeys: [],
                items: new Map(),
                canNavigateAction: 0
            };

            view.startup = function () {

                if(view.publicVars.moduleHeaderConfig) {
                    view.privateVars.itemsKeys.push('home-header');

                    view.privateVars.items.set('home-header', {
                        init: false,
                        module: moduleHomeHeader,
                        config: view.publicVars.moduleHeaderConfig,
                        callbacks: {}
                    });
                }

                if(view.publicVars.moduleCompanyConfig) {
                    view.privateVars.itemsKeys.push('home-company');

                    view.privateVars.items.set('home-company', {
                        init: false,
                        module: moduleHomeCompany,
                        config: view.publicVars.moduleCompanyConfig,
                        callbacks: {}
                    });
                }

                if(view.publicVars.moduleFilmsConfig) {
                    view.privateVars.itemsKeys.push('home-films');

                    view.privateVars.items.set('home-films', {
                        init: false,
                        module: moduleHomeFilms,
                        config: view.publicVars.moduleFilmsConfig,
                        callbacks: {}
                    });
                }

                if(view.publicVars.moduleTvConfig) {
                    view.privateVars.itemsKeys.push('home-tv');

                    view.privateVars.items.set('home-tv', {
                        init: false,
                        module: moduleHomeTv,
                        config: view.publicVars.moduleTvConfig,
                        callbacks: {}
                    });
                }

                if(view.publicVars.moduleNewsConfig) {
                    view.privateVars.itemsKeys.push('home-news');

                    view.privateVars.items.set('home-news', {
                        init: false,
                        module: moduleHomeNews,
                        config: view.publicVars.moduleNewsConfig,
                        callbacks: {}
                    });
                }

                if(view.publicVars.moduleGalleryConfig) {
                    view.privateVars.itemsKeys.push('home-gallery');

                    view.privateVars.items.set('home-gallery', {
                        init: false,
                        module: moduleHomeGallery,
                        config: view.publicVars.moduleGalleryConfig,
                        callbacks: {}
                    });
                }

                if(view.publicVars.moduleGamesConfig) {
                    view.privateVars.itemsKeys.push('home-games');

                    view.privateVars.items.set('home-games', {
                        init: false,
                        module: moduleHomeGames,
                        config: view.publicVars.moduleGamesConfig,
                        callbacks: {}
                    });
                }

                view.methods.handleCurrentScrollPosition();

                // moduleMediaCarousel.init(view.publicVars.moduleMediaCarouselConfig);
                // moduleVideoCarousel.init(view.publicVars.moduleVideoCarouselConfig);

            };

            view.bind = function () {
                $(window).scroll(function () {

                    let ticking = false;

                    if (view.privateVars.canNavigateAction === 0) {

                        if (!ticking) {
                            window.requestAnimationFrame(function () {
                                view.methods.handleCurrentScrollPosition();
                                ticking = false;
                            });
                        }
                        ticking = true;
                    }
                });

                $(window).resize(() => {
                    view.methods.handleCurrentScrollPosition();
                });

                $(window).on('orientationchange', () => {
                    view.methods.handleCurrentScrollPosition();
                });
            };

            view.methods = {
                handleCurrentScrollPosition: () => {

                    const systemCurrentScroll = $(document).scrollTop();

                    for (let [key, value] of view.privateVars.items) {

                        const targetPos = $(view.publicVars.cssId.layout.navigateTargetId + '-' + key).offset();

                        view.methods.handleModuleInit(systemCurrentScroll, key, targetPos);
                    }
                },

                handleModuleInit: (currentScroll, key, targetPos) => {

                    if (view.privateVars.items.get(key).module && view.privateVars.items.get(key).init === false) {
                        const rect = $(view.publicVars.cssId.layout.navigateTargetId + '-' + key)[0].getBoundingClientRect();
                        const scrollPlusWindowHeight = $(window).height() + currentScroll;

                        const specialModifier = $(view.publicVars.cssId.headerCls).outerHeight();

                        if ((targetPos.top - 200) < scrollPlusWindowHeight &&
                            (scrollPlusWindowHeight < (targetPos.top + rect.height) || currentScroll < (targetPos.top + rect.height + specialModifier))) {

                            view.methods.fireModuleStart(key);

                        }
                    }

                },

                fireModuleStart: (key) => {
                    if (view.privateVars.items.get(key).module && view.privateVars.items.get(key).init === false) {

                        view.privateVars.items.get(key).init = true;
                        view.privateVars.items.get(key).module.init(
                            view.privateVars.items.get(key).config,
                            view.privateVars.items.get(key).callbacks
                        );
                    }
                },
            };

            /* custom events */
            //pubSub.subscribe('view/actionShowFormThx', view.methods.actionShowFormThx);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                }
            };


        })();


    });
